import { PLATFORM_TYPE } from '../enums/model.enums';
/**
 * class {Platform}
 * should be used to display platform related information
 */
export class Platform {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param id
     * @param name
     * @param type
     */
    constructor(id, name, type) {
        this._id = id;
        this._name = name;
        this._type = type;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {Platform}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.id = values.id || '';
        sanitizedValues.name = values.name || '';
        sanitizedValues.type = values.type !== undefined ? values.type : PLATFORM_TYPE.ANY;
        return new Platform(sanitizedValues.id, sanitizedValues.name, sanitizedValues.type);
    }
    /**
     * gets the internal _id
     * @returns {string}
     */
    get id() {
        return this._id;
    }
    /**
     * sets the internal _id
     * @param value
     */
    set id(value) {
        this._id = value;
    }
    /**
     * gets the platform name
     * @returns {string}
     */
    get name() {
        return this._name;
    }
    /**
     * sets the platform name
     * @param name
     */
    set name(name) {
        this._name = name;
    }
    /**
     * gets the platform type
     * @returns {string}
     */
    get type() {
        return this._type;
    }
    /**
     * sets the platform type
     * @param type
     */
    set type(type) {
        this._type = type;
    }
}
//# sourceMappingURL=platform.js.map